var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass:
        "borderBottom rounded-md rounded-b-none sm:px-3 sm:flex justify-between w-full",
    },
    [
      _c(
        "div",
        {
          staticClass:
            "sm:hidden h-8 w-8 min-w-8 flex justify-center items-center",
        },
        [
          _c(
            "button",
            {
              staticClass: "mt-1",
              on: { click: _vm.clearSelectedConversation },
            },
            [
              _c(
                "svg",
                {
                  attrs: {
                    width: "14",
                    height: "14",
                    viewBox: "0 0 14 14",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                  },
                },
                [
                  _c("path", {
                    attrs: {
                      d: "M9.8987 2.9843V1.92747C9.8987 1.83587 9.79343 1.78528 9.72233 1.84133L3.55905 6.6552C3.50669 6.69592 3.46431 6.74807 3.43517 6.80766C3.40602 6.86725 3.39087 6.93271 3.39087 6.99905C3.39087 7.06539 3.40602 7.13085 3.43517 7.19044C3.46431 7.25003 3.50669 7.30217 3.55905 7.3429L9.72233 12.1568C9.7948 12.2128 9.8987 12.1622 9.8987 12.0706V11.0138C9.8987 10.9468 9.86726 10.8825 9.8153 10.8415L4.89343 6.99973L9.8153 3.15657C9.86726 3.11555 9.8987 3.0513 9.8987 2.9843V2.9843Z",
                      fill: "black",
                      "fill-opacity": "0.88",
                    },
                  }),
                ]
              ),
            ]
          ),
        ]
      ),
      _c(
        "div",
        { staticClass: "w-full flex flex-row items-center justify-between" },
        [
          _c("div", { staticClass: "flex items-center sm:w-7/12" }, [
            _c(
              "p",
              {
                staticClass:
                  "truncate flex-grow font-semibold text-xl mr-4 cursor-default titleMain",
                class: _vm.onlyParticipantLeftStyle,
              },
              [_vm._v(" " + _vm._s(_vm.conversationTitle) + " ")]
            ),
          ]),
          _vm.isGroupConversation
            ? _c(
                "div",
                { staticClass: "flex ml-auto justify-center items-center" },
                [
                  _vm.isGroupConversation
                    ? _c(
                        "button",
                        {
                          staticClass:
                            "h-6 w-6 mt-0.5 cursor-pointer flex-shrink-0 focus:outline-none hover:text-primary-500",
                          on: {
                            mouseover: function ($event) {
                              _vm.isHoveredChat = true
                            },
                            mouseout: function ($event) {
                              _vm.isHoveredChat = false
                            },
                            click: _vm.openDetailsModal,
                          },
                        },
                        [
                          !_vm.isHoveredChat
                            ? [
                                _c(
                                  "svg",
                                  {
                                    attrs: {
                                      xmlns: "http://www.w3.org/2000/svg",
                                      width: "5",
                                      height: "18",
                                      viewBox: "0 0 5 18",
                                      fill: "none",
                                    },
                                  },
                                  [
                                    _c("path", {
                                      attrs: {
                                        d: "M2.60867 2.18114C2.13042 2.18114 1.74273 2.56884 1.74273 3.04708C1.74273 3.52533 2.13042 3.91302 2.60867 3.91302C3.08691 3.91302 3.47461 3.52533 3.47461 3.04708C3.47461 2.56884 3.08691 2.18114 2.60867 2.18114Z",
                                        stroke: "#010A11",
                                        "stroke-width": "1.73188",
                                        "stroke-linecap": "round",
                                        "stroke-linejoin": "round",
                                      },
                                    }),
                                    _c("path", {
                                      attrs: {
                                        d: "M2.60867 8.24276C2.13042 8.24276 1.74273 8.63045 1.74273 9.1087C1.74273 9.58694 2.13042 9.97464 2.60867 9.97464C3.08691 9.97464 3.47461 9.58694 3.47461 9.1087C3.47461 8.63045 3.08691 8.24276 2.60867 8.24276Z",
                                        stroke: "#010A11",
                                        "stroke-width": "1.73188",
                                        "stroke-linecap": "round",
                                        "stroke-linejoin": "round",
                                      },
                                    }),
                                    _c("path", {
                                      attrs: {
                                        d: "M2.60867 14.3043C2.13042 14.3043 1.74273 14.692 1.74273 15.1703C1.74273 15.6485 2.13042 16.0362 2.60867 16.0362C3.08691 16.0362 3.47461 15.6485 3.47461 15.1703C3.47461 14.692 3.08691 14.3043 2.60867 14.3043Z",
                                        stroke: "#010A11",
                                        "stroke-width": "1.73188",
                                        "stroke-linecap": "round",
                                        "stroke-linejoin": "round",
                                      },
                                    }),
                                  ]
                                ),
                              ]
                            : _vm._e(),
                          _vm.isHoveredChat
                            ? [
                                _c(
                                  "svg",
                                  {
                                    attrs: {
                                      xmlns: "http://www.w3.org/2000/svg",
                                      width: "5",
                                      height: "18",
                                      viewBox: "0 0 5 18",
                                      fill: "none",
                                    },
                                  },
                                  [
                                    _c("path", {
                                      attrs: {
                                        d: "M2.60867 2.1812C2.13042 2.1812 1.74273 2.5689 1.74273 3.04714C1.74273 3.52539 2.13042 3.91309 2.60867 3.91309C3.08691 3.91309 3.47461 3.52539 3.47461 3.04714C3.47461 2.5689 3.08691 2.1812 2.60867 2.1812Z",
                                        stroke: "#1A7BEE",
                                        "stroke-width": "1.73188",
                                        "stroke-linecap": "round",
                                        "stroke-linejoin": "round",
                                      },
                                    }),
                                    _c("path", {
                                      attrs: {
                                        d: "M2.60867 8.24273C2.13042 8.24273 1.74273 8.63042 1.74273 9.10867C1.74273 9.58691 2.13042 9.97461 2.60867 9.97461C3.08691 9.97461 3.47461 9.58691 3.47461 9.10867C3.47461 8.63042 3.08691 8.24273 2.60867 8.24273Z",
                                        stroke: "#1A7BEE",
                                        "stroke-width": "1.73188",
                                        "stroke-linecap": "round",
                                        "stroke-linejoin": "round",
                                      },
                                    }),
                                    _c("path", {
                                      attrs: {
                                        d: "M2.60867 14.3042C2.13042 14.3042 1.74273 14.6919 1.74273 15.1702C1.74273 15.6484 2.13042 16.0361 2.60867 16.0361C3.08691 16.0361 3.47461 15.6484 3.47461 15.1702C3.47461 14.6919 3.08691 14.3042 2.60867 14.3042Z",
                                        stroke: "#1A7BEE",
                                        "stroke-width": "1.73188",
                                        "stroke-linecap": "round",
                                        "stroke-linejoin": "round",
                                      },
                                    }),
                                  ]
                                ),
                              ]
                            : _vm._e(),
                        ],
                        2
                      )
                    : _vm._e(),
                  _vm._l(
                    _vm.participantsForCircles,
                    function (participant, index) {
                      return _c("CircleWithInitials", {
                        key: index,
                        staticClass: "-mr-1.5 flex",
                        class: _vm.deletedParticipantCircleStyle(participant),
                        attrs: {
                          title: participant.initial,
                          avatar: participant.avatar,
                          customClass: "border border-1 border-white",
                          tooltipPlacement: _vm.tooltipPlacement.LEFT,
                          variant: _vm.TooltipVariants.DARK,
                          tooltipClasses: "inboxWidth",
                          showTooltip: "",
                          large: "customHo",
                          primary: "",
                        },
                      })
                    }
                  ),
                  _vm.participantsRest
                    ? _c(
                        "span",
                        {
                          staticClass:
                            "flex items-center justify-center rounded-full text-white relative newCircle",
                        },
                        [
                          _c("span", { staticClass: "additionalNumber" }, [
                            _vm._v("+" + _vm._s(_vm.numberOfRestParticipants)),
                          ]),
                        ]
                      )
                    : _vm._e(),
                ],
                2
              )
            : _vm._e(),
          !_vm.isGroupConversation
            ? _c(
                "button",
                {
                  staticClass: "leaveButton",
                  on: {
                    mouseover: function ($event) {
                      _vm.isHovered = true
                    },
                    mouseout: function ($event) {
                      _vm.isHovered = false
                    },
                    click: _vm.leaveConversation,
                  },
                },
                [
                  !_vm.isHovered
                    ? [_c("LeaveChat", { staticClass: "w-4 h-4 mr-2" })]
                    : _vm._e(),
                  _vm.isHovered
                    ? [_c("LeaveChatHover", { staticClass: "w-4 h-4 mr-2" })]
                    : _vm._e(),
                  _vm._v(
                    _vm._s(
                      _vm.isGroupConversation
                        ? "Leave Conversation"
                        : "Leave Chat"
                    ) + " "
                  ),
                ],
                2
              )
            : _vm._e(),
        ]
      ),
      _c("ConversationDetailsModal", {
        attrs: {
          conversationName: _vm.conversationTitle,
          participants: _vm.participants,
        },
        on: { leaveConversation: _vm.leaveConversation },
        model: {
          value: _vm.conversationDetailsModal,
          callback: function ($$v) {
            _vm.conversationDetailsModal = $$v
          },
          expression: "conversationDetailsModal",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }